export class LoginModel {
    constructor(
        public Email: string = null,
        public Password: string = null,
        public RememberMe: boolean = false
    ) { }
}